function Footer() {
  return (
    <div className="relative bottom-0 w-full text-center text-gray-100 font-medium text-lg py-2 bg-gray-900" >
      Made with ❤️ by Ajay Sinha
    </div>
  )
}

export default Footer
